<script setup lang="ts">
import {
    currentUserLat, currentUserLng
} from '@deliveryteam-spa-orders-vue/refs/UserCurrentLocation';
import { useMyOrdersMap } from '@deliveryteam-spa-orders-vue/composables/useMyOrdersMap';

const { googleDirectionsEmbedUrl } = useMyOrdersMap(currentUserLat, currentUserLng);

</script>

<template>
    <div class="w-full h-[50vh] min-h-[220px] md:min-h-[320px] bg-muted/20">
        <iframe v-if="googleDirectionsEmbedUrl"
                width="100%"
                height="100%"
                class="rounded-none"
                frameborder="0"
                allow="accelerometer *; gyroscope *;"
                referrerpolicy="no-referrer-when-downgrade"
                allowfullscreen="false"
                :src="googleDirectionsEmbedUrl">
        </iframe>
        <div v-else
             class="h-full w-full flex items-center justify-center text-sm text-muted-foreground">
            No route yet (needs at least two points)
        </div>
    </div>
</template>
